/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';

import {UserProfileSaverService} from '../../components/session/user-profile-saver.service';
import {SignalAdminResourceContextActionsComponent} from '../common/controller/signal-admin-resource-context-actions.component';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SignalAdminResourceTitleComponent} from '../common/controller/signal-admin-resource-title.component';
import {ListDefaultActionsComponent} from '../common/directives/list-default-actions.component';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {AdnRouterHelperApi, StateDeclarationBuilder} from '../routing/state-utils';
import {FolderApiService, FolderModel} from './folder-api.service';
import {FolderCopyModalComponent} from './folder-copy-modal.component';
import {FolderItemPageComponent} from './folder-item-page.component';
import {FolderRoutePageComponent} from './folder-route-page.component';

export function folderStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  const api = adnRouterHelper.services.service(FolderApiService);
  const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);
  const rh = adnRouterHelper.createRouterHelper('folders.folder', FolderApiService, 'app.dat-seg', 'app');
  const copyConfig = {
    modalComponent: FolderCopyModalComponent,
    stateUrl: 'app.dat-seg.folders.folder',
    lcase: 'folder',
    ucase: 'Folder'
  };

  states.add(rh.listPath(), rh.list({
    resolve: {listReadOnly: () => false},
    views: {
      'content@app': {component: FolderRoutePageComponent, bindings: {readOnly: 'listReadOnly'}},
      'context@app': {component: ListDefaultActionsComponent, bindings: {readOnly: 'listReadOnly', newStateName: 'listNewStateName'}},
      'title@app': stateTitleView()
    }
  }));
  states.add(rh.newItemPath(), rh.newItem());
  states.add(rh.itemPath(), rh.item({
    resolve: {
      folderPage: function($stateParams: any) {
        if ($stateParams.isNew) {
          return new SignalAdminResourcePageState<FolderModel>(
            {id: $stateParams.id, objectState: 'ACTIVE', validationWarnings: []}, true, false, api, 'Folder', 'name', copyConfig
          );
        }
        return firstValueFrom(api.get($stateParams.id).pipe(
          tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
        )).then((model) => new SignalAdminResourcePageState(model, false, false, api, 'Folder', 'name', copyConfig));
      },
      model: function(folderPage: SignalAdminResourcePageState<FolderModel>) {
        return folderPage.model();
      }
    },
    views: {
      'content@app': {component: FolderItemPageComponent, bindings: {state: 'folderPage'}},
      'context@app': {component: SignalAdminResourceContextActionsComponent, bindings: {state: 'folderPage'}},
      'title@app': {component: SignalAdminResourceTitleComponent, bindings: {state: 'folderPage'}}
    }
  }));
  return states.build();
}
